export default ({app}) =>
	`${app.searchTerm}-${app.selectedTag}-${app.startTimestamp}-${app.endTimestamp}`;
